/* eslint-disable react-hooks/rules-of-hooks */
import { toast } from "react-toastify";
import { config } from "../../configVar";
import { ReduxThunkAction } from "../../store";
import { gerenciaTecnicaSlice, LocationSlice } from "../index";
import { RequirementLocation } from "./interfaces";

const serverUrl = config.serverUrl;

export const loadLocationDetails =
    (id: string, from?: string): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                dispatch(LocationSlice.actions.setLoading(true));
                let token = localStorage.getItem("authToken");
                let users;
                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                if (
                    !getState().gerenciaTecnica?.users ||
                    (getState().gerenciaTecnica.users ?? []).length === 0
                ) {
                    const responseGetUsers = await fetch(
                        `${serverUrl}/api/shared/listOfUsers`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: `${token}`,
                            },
                        }
                    );

                    users = await responseGetUsers.json();
                    dispatch(gerenciaTecnicaSlice.actions.setUsers(users));
                }

                const response = await fetch(
                    `${serverUrl}/api/projects/getLocationById`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                            locationId: id,
                        },
                    }
                );

                const data = await response.json();
               
                dispatch(LocationSlice.actions.setLocation({ ...data, updatedFrom: from || "" }));

                const responseCatChanges = await fetch(
                    `${serverUrl}/api/operations/getLocationCategoryChangesById`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                            locationId: id,
                        },
                    }
                );

                const dataCatChange = await responseCatChanges.json();

                dispatch(LocationSlice.actions.setLocationCategoriesChanges(dataCatChange));

            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(LocationSlice.actions.setLoading(false));
            }
        };

export const editLocationSetPoint =
    (setPoint: any): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }
                //dispatch
                dispatch(LocationSlice.actions.setLocationSetPoint(setPoint));
            } catch (error) {
                console.log({ error });
            }
        };

export const createSetPoint =
    (setPoint: any): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/projects/addSingleSetPointToLocation`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(setPoint),
                    }
                );

                const data = await response.json();

                if (response.status === 500) {
                    toast.error(data.message);
                }

                if (response.status === 201) {
                    toast.success("SetPoint creado correctamente");
                    dispatch(loadLocationDetails(setPoint.locationId));
                }
            } catch (error) {
                console.log({ error });
                toast.error("Error al crear el setPoint");
            }
        };
export const updateLocationSetPoint =
    (data: any): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/projects/addSetPointToLocation`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(data),
                    }
                );

                const res = await response.json();

                //dispatch
                dispatch(loadLocationDetails(data.locationId));
            } catch (error) {
                console.log({ error });
            }
        };

export const AddRequirementsInLocation =
    (data: RequirementLocation): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                //response

                const response = await fetch(
                    `${serverUrl}/api/operations/addRequirementToLocation`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(data),
                    }
                );

                if (response.status === 201) {
                    toast.success("Requerimientos agregados correctamente");
                    dispatch(loadLocationDetails(data.locationId, "requirements"));
                }

                //dispatch
            } catch (error) {
                console.log({ error });
            }
        };

export const loadVariables =
    (): ReduxThunkAction => async (dispatch, getState) => {
        try {
            let token = localStorage.getItem("authToken");

            if (!token) {
                // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                return;
            }

            const response = await fetch(
                `${serverUrl}/api/operations/getVariablesList`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                }
            );

            const data = await response.json();

            return data;
        } catch (error) {
            console.log({ error });
        }
    };

export const createLocationTag =
    (tag: any): ReduxThunkAction =>
        async (dispatch) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/configuration/add-tag-to-location`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(tag),
                    }
                );

                if (response.status === 201) {
                    toast.success("Tag creado correctamente");
                    dispatch(loadLocationDetails(tag.locationId, "tags"));
                }
                // return data;
            } catch (error) {
                console.log({ error });
            }
        };

export const deleteLocationTag =
    (data: any, locationId: string): ReduxThunkAction =>
        async (dispatch) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/configuration/remove-tag-from-location`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(data),
                    }
                );

                if (response.status === 200) {
                    toast.success("Tag eliminado correctamente");
                    dispatch(loadLocationDetails(locationId, "tags"));
                }
            } catch (error) {
                console.log({ error });
            }
        };

export const deletedRequirement =
    (data: any, locationId: string): ReduxThunkAction =>
        async (dispatch) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/operations/deleteRequirementFromLocation`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify(data),
                    }
                );

                if (response.status === 200) {
                    toast.success("Requerimiento eliminado correctamente");
                    dispatch(loadLocationDetails(locationId));
                }
            } catch (error) { }
        };

export const uploadFileToServer =
    (payload: { name: string; tags: string[]; type: string; file: File; description: string,
                locationId: string, originFieldActivityId: string, sources: string, locationName:string, 
                originFieldActivityDescription:string, attachedRelatedDate: string }, setShowUpload:any): ReduxThunkAction =>
        async (dispatch, getState) => {
            try {
                dispatch(LocationSlice.actions.setLoading(true));
                const token = localStorage.getItem("authToken");
                if (!token) return;

                const formData = new FormData();
                formData.append("name", payload.name);
                formData.append("type", payload.type);
                formData.append("description", payload.description);
                formData.append("file", payload.file);
                formData.append("tags", JSON.stringify(payload.tags));
                formData.append("locationId", payload.locationId);
                formData.append("originFieldActivityId", payload.originFieldActivityId);
                formData.append("sources", payload.sources);
                formData.append("locationName", payload.locationName);
                formData.append("attachedRelatedDate", payload.attachedRelatedDate);
                formData.append("originFieldActivityDescription", payload.originFieldActivityDescription);

                const response = await fetch(`${serverUrl}/api/shared/uploadFile`, {
                    method: "POST",
                    headers: {
                        authorization: `${token}`,
                    },
                    body: formData,
                });

                console.log({response: response.ok, status: response.status})

                if (!response.ok) {
                    toast.error("Archivo No cargado, favor intentarlo de nuevo");
                }

                if (response.ok) {
                    toast.success("Archivo cargado");
                    dispatch(loadLocationDetails(payload.locationId, "attachments"));
                    setShowUpload(false);
                }

            } catch (error) {
                console.log({ error });
            } finally {
                dispatch(LocationSlice.actions.setLoading(false));
            }
        };

export const deletedFile =
    (fileId: string, locationId: string): ReduxThunkAction =>
        async (dispatch) => {
            try {
                let token = localStorage.getItem("authToken");

                if (!token) {
                    // dispatch(mainSlice.actions.setUploadingStep("Error Uploading"));
                    return;
                }

                const response = await fetch(
                    `${serverUrl}/api/shared/deleteFile`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `${token}`,
                        },
                        body: JSON.stringify({ fileId }),
                    }
                );

                if (response.status === 200) {
                    toast.success("Requerimiento eliminado correctamente");
                    dispatch(loadLocationDetails(locationId, "attachments"));
                }
            } catch (error) { }
        };